import * as React from 'react'
import { IStationUserSearchObject } from '../../../types'
import PreloaderCircle from '../../ui/PreloaderCircle'
import ImageView from 'src/components/ui/ImageView'
import { RouteComponentProps } from 'react-router'
import FloatingForm from 'src/components/ui/form/FloatingForm'
import UIMessages from 'src/utils/ui-messages'
import FormLabel from 'src/components/ui/form/FormLabel'

export interface IStationUserViewPaneProps {
  organizationName: string
  stationUser?: IStationUserSearchObject
  isFetching: boolean
  error: string
  routeProps: RouteComponentProps<any>
  onResetClick: (teamMember: IStationUserSearchObject) => any
  onSendInviteClick: (teamMember: IStationUserSearchObject) => any
}

export interface IStationUserViewPaneParams {
  id: string
}

interface IStationUserViewPaneState {
  isSaving: boolean
}

interface IDetailsInfoProps {
  countryCode: string
  email: string
  organizationName: string
  phoneNumber: string
  userName: string
}

interface IMainInfoProps {
  avatarUrl: string
  name: string
  id: string
}

const MainInfo = ({ avatarUrl, name, id }: IMainInfoProps) => (
  <div className='column-gap-16 flex items-center'>
    <div className='pb1'>
      <ImageView entityId={id} isRounded={true} />
    </div>
    <p className='fs-20 font-grey3 m0'>{name}</p>
  </div>
)

const DetailsInfo = ({ countryCode, email, organizationName, phoneNumber, userName }: IDetailsInfoProps) => {
  const {
    form: { email: emailLabel, organization, phoneNumber: phoneNumberLabel, username: usernameLabel }
  } = UIMessages.teamMember
  const formattedPhoneNumber = phoneNumber !== '' ? `+${countryCode || ''} ${phoneNumber}` : ''
  const personalInfoMapping = [
    { label: organization, value: organizationName },
    { label: usernameLabel, value: userName },
    { label: emailLabel, value: email },
    { label: phoneNumberLabel, value: formattedPhoneNumber }
  ]

  return (
    <>
      {personalInfoMapping.map(({ label, value }) => (
        <div className='mbsc-col-12 mbsc-col-md-6 mbsc-col-lg-4 mbsc-padding' key={label}>
          <FormLabel>{label}</FormLabel>
          <div className='h5 mt1'>{value}</div>
        </div>
      ))}
    </>
  )
}

class StationUserViewPane extends React.Component<IStationUserViewPaneProps, IStationUserViewPaneState> {
  constructor(props: IStationUserViewPaneProps) {
    super(props)
    this.state = {
      isSaving: false
    }
  }

  public render() {
    const { organizationName, stationUser, isFetching, error, routeProps } = this.props
    const style: any = {
      pointerEvents: this.state.isSaving ? 'none' : 'auto',
      opacity: this.state.isSaving ? 0.4 : 1.0
    }

    return (
      <section className='su-personal-info-details-container' style={style}>
        <FloatingForm>
          <div className='mbsc-grid mb3 no-padding'>
            <div className='mbsc-row'>
              {isFetching && (
                <div className='mbsc-col-12 flex justify-center'>
                  <PreloaderCircle loading={true} />
                </div>
              )}
              {!isFetching && stationUser && (
                <>
                  <div className='mbsc-col-12 mbsc-padding'>
                    <MainInfo
                      avatarUrl='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRPAD7cIOpVaM6tNyFR1LY52GN6ZTV34SDIV9S4iSJzpN-FK5SXvw'
                      id={stationUser ? stationUser.userId : ''}
                      name={stationUser.name}
                    />
                  </div>
                  <DetailsInfo
                    countryCode={stationUser.countryCode}
                    email={stationUser.email}
                    organizationName={organizationName}
                    phoneNumber={stationUser.phone}
                    userName={stationUser.username}
                  />
                </>
              )}
            </div>
          </div>
        </FloatingForm>
      </section>
    )
  }
}

export default StationUserViewPane



// WEBPACK FOOTER //
// ./src/components/station-user/view/StationUserInfo.tsx